import { ExchangeKeyEnum } from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../../client/core/getCore';
import { getDefaultClient } from '../../../../client/defaultClient';
import { createApiClient } from '../../../apiClient';
import type { TransferDestinationResponse } from '../kraken.types';

/**
 * Gets the whitelisted addresses for Kraken transfers
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns Transfer destinations response with whitelisted addresses
 */
export const getKrakenWhitelistedAddresses = async (
  client = getDefaultClient()
): Promise<TransferDestinationResponse> => {
  const core = getCore(client);
  const apiClient = createApiClient({ includeMfaToken: true }, client);

  const response = await apiClient.getExchangeTransferDestinations({
    environmentId: core.environmentId,
    exchangeKey: ExchangeKeyEnum.Kraken,
  });

  return response;
};
